import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TileContainer } from '@vds/tiles';
import { useSelector, shallowEqual } from 'react-redux';
import { TextLink } from '@vds/buttons';
import { selectStateCache } from '../@selectors';
import { selectStateCache as selectCheckoutStateCache } from '../../@Redux/selectors/checkout.selectors';
import { Title } from '../../../common/Typography/index';
import { useMiniCartHooks } from '../@Redux/OrderSummary.hooks';
import { isExpressCheckout, priceFormat } from '../../../common/Helpers';
import { Margin } from '../../../Movers/common/styles';
import NextBillSummary from '../../ExpressCheckout/Components/NextBillSummary';
import './mobileCart.css';
import PromoCode from '../PromoCode';
import '../DesktopCart/desktopCart.css';
import ReviewPrice from '../ReviewPrice';
import { checkoutLabels } from '../../ExpressCheckout/Components/labels';

const MobileCart = (props) => {
  const { clickPromo } = props;
  const stateCacheCart = useSelector((state) => selectStateCache(state), shallowEqual);
  const stateCacheCheckout = useSelector((state) => selectCheckoutStateCache(state), shallowEqual);
    const { dueAmount } = useMiniCartHooks(stateCacheCart,stateCacheCheckout);
  const { dueTodayAmount, dueMonthlyAmount } = dueAmount || {};
  const [showCart, setShowCart] = useState(false);

  const cqlabels = window?.checkoutCQ?.output?.checkoutLabels ? window?.checkoutCQ?.output?.checkoutLabels : checkoutLabels;

  const showReviewPriceDetails = () => {
    setShowCart(!showCart);
    console.log('ReviewPriceDetails link clicked');
  };

  return (
    <>
      <div className="orderSummary">
        <TileContainer padding="12px 16px 24px 16px" width="100%" height="100%" backgroundColor="white" showBorder>
          <div className="tileContainer">
            <Title color="black" size="TitleMedium" bold>
              Due today <span className="floatRight">{priceFormat(dueTodayAmount)}</span>
            </Title>
            <Margin top="20px">
              <Title color="black" size="TitleMedium" bold>
                Due monthly for 5G Home <span className="floatRight">{priceFormat(dueMonthlyAmount)}</span>
              </Title>
            </Margin>

            <Margin top="20px" bottom="24px">
              <TextLink
                ariaLabel="Review price details"
                onClick={() => showReviewPriceDetails()}
                onKeyDown={() => showReviewPriceDetails()}
                tabIndex="0"
                type="standAlone"
                id="reviewpricedetails"
                data-track={isExpressCheckout()? '{"type":"link","name":"Review price details|order Summary","data":{"page":{"throttle":"nsa version|vhi|ec y"},"target":{"sandBox":"FWA_Express_T_Checkout"}}}': '{"type":"link","name":"Review price details|order Summary"}'}  
              >
                Review price details
              </TextLink>
            </Margin>
            <NextBillSummary pageName="expresscheckout" {...cqlabels} />
            <PromoCode onClickPromo={clickPromo} />
          </div>
        </TileContainer>
      </div>
      {showCart && (
        <ReviewPrice showReviewPrice={showReviewPriceDetails}/>
      )}
    </>
  );
};

MobileCart.propTypes = {
  clickPromo: PropTypes.func,
};

export default MobileCart;
